<template>
  <ul>
    <li @click="goToRoute" tabindex="0" id="/dicas-de-gestao" role="button">
      Dicas de poupança
    </li>
    <li @click="goToRoute" tabindex="0" id="/sobre-a-aplicacao" role="button">
      Sobre minhamola
    </li>
    <li @click="goToRoute" tabindex="0" id="/perguntas-frequentes" role="button">
      Perguntas frequentes
    </li>
    <li @click="goToRoute" tabindex="0" id="/contacte-me" role="button">Contacte-me</li>
    <li v-if="isLoggedIn" tabindex="0">
      <AppButton @click.native="logOut" class="signout-button" text="sair"/>
    </li>
    <li v-if="!isLoggedIn">
      <AppButton @click.native="goToRoute" id="/entrar" class="signin-button" text="entrar" />
      <AppButton
        @click.native="goToRoute"
        id="/registar-se"
        class="signup-button"
        text="regista-te"
      />
    </li>
    <!-- <li>
      <button class="app-install-button">
        <AppIcon iconName="install" />
        instalar minhamola
      </button>
    </li> -->
  </ul>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import AppButton from "@/components/AppButton.vue";
// import AppIcon from "@/components/AppIcon.vue";
import { requestBuilder } from "../misc/util";

export default {
  name: "Menu",
  components: {
    AppButton
  },
  created() {
    this.checkAuthStatus();
  },
  mounted() {
    this.checkAuthStatus();
  },
  computed: {
    ...mapGetters(["isLoggedIn"])
  },
  methods: {
    ...mapActions(["changeMenuStatus", "changeLoginState", "changeUserId", "checkAuthStatus"]),
    async logOut() {
      this.changeUserId(null);
      this.changeLoginState(false);
      this.changeMenuStatus(false);

      if (this.$route.name !== "home") this.$router.push({ name: "home" });

      const url = "/users/logout";
      const method = "GET";
      const requestOptions = requestBuilder(url, method);

      try {
        await axios.request(requestOptions);
      } catch (error) {
        console.log(error);
      }
    },
    goToRoute(e) {
      this.changeMenuStatus(false);
      const nextRoute = e.srcElement.id;
      const currentRoute = this.$route.path;

      if (currentRoute !== nextRoute) this.$router.push(nextRoute);
    }
  }
};
</script>

<style scoped>
ul {
  display: flex;
  flex-direction: column;
  z-index: 400;
  width: 100%;
  background-color: var(--color-white);
  padding: 1.2rem;
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.1));
}

ul li {
  color: var(--color-primary);
  margin-bottom: 2rem;
  cursor: pointer;
}

ul li:last-of-type {
  margin-bottom: 0.2rem;
}

ul li span {
  font-weight: 600;
}

.signin-button {
  all: unset;
  text-align: center;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  padding: 0.8rem 1.4rem;
  width: fit-content;
  color: var(--color-primary);
}

.signup-button {
  background-color: var(--color-primary);
  color: var(--color-quaternary);
  margin-left: 1rem;
  margin-bottom: 0.8rem;
}

.signout-button {
  background-color: var(--color-senary);
  color: var(--color-quaternary);
  margin-bottom: 0.8rem;
}

.app-install-button {
  color: var(--color-quaternary);
  background-color: var(--color-secondary);
  border: none;
  border-radius: 5px;
  padding: 0.8rem 1.4rem;
  width: fit-content;
  display: flex;
  align-items: center;
  font-size: 1rem;
}

.app-install-button svg {
  fill: var(--color-quaternary);
  margin-right: 1rem;
}

.divider {
  max-width: 100%;
  height: 2px;
  display: flex;
  margin-bottom: 1.4rem;
}
</style>
